/* ============================================================================
   Portal do Responsável — caminho e regra de acesso.
   ============================================================================
   A rota e o item de menu ("Meus filhos") vêm do cadastro do backend
   (configuration_links, configuration_menus, access_roles_menus e
   access_roles_links), como as demais telas do AVA.

   O path precisa bater com o `path` cadastrado em configuration_links, e o
   link precisa de `exact = false`: a sub-rota /aluno/:alunoId é resolvida em
   pages/PortalResponsavel/App.jsx.

   Acesso: só o papel 8 (Responsável). A página confere o papel ativo por conta
   própria, então quem chegar pela URL com outro papel vê o aviso, não o painel. */

export const PORTAL_RESPONSAVEL_PATH = "/portal-responsavel";

/** Único papel que abre o painel — ver a nota no topo do arquivo. */
const RESPONSAVEL_ROLE_ID = 8;

export const temAcessoPortalResponsavel = activeRoleId =>
  activeRoleId === RESPONSAVEL_ROLE_ID;
